import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { services, regions } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <span className="text-4xl font-bold text-white" style={{ fontFamily: '"Outfit", sans-serif' }}>PULVISTAR</span>
            </div>
            <p className="text-sm text-gray-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>
              Innovation - Ecology - Drone cleaning
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4" style={{ fontFamily: '"Outfit", sans-serif' }}>
              Nos solutions
            </h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-sm hover:text-cyan-400 transition-colors"
                    style={{ fontFamily: '"Inter", sans-serif' }}
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Zones */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4" style={{ fontFamily: '"Outfit", sans-serif' }}>
              Zones d'intervention
            </h3>
            <ul className="space-y-2">
              {regions.slice(0, 5).map((region) => (
                <li key={region.slug}>
                  <Link
                    to={`/zone/${region.slug}`}
                    className="text-sm hover:text-cyan-400 transition-colors"
                    style={{ fontFamily: '"Inter", sans-serif' }}
                  >
                    {region.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4" style={{ fontFamily: '"Outfit", sans-serif' }}>
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <a href="tel:+33184180342" className="text-sm hover:text-cyan-400 transition-colors">
                  01 84 18 03 42
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:contact@pulvistar.fr" className="text-sm hover:text-cyan-400 transition-colors">
                  contact@pulvistar.fr
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">France entière</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500" style={{ fontFamily: '"Inter", sans-serif' }}>
            © {currentYear} PULVISTAR. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="text-sm text-gray-500 hover:text-cyan-400 transition-colors">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="text-sm text-gray-500 hover:text-cyan-400 transition-colors">
              Confidentialité
            </Link>
            <Link to="/cgv" className="text-sm text-gray-500 hover:text-cyan-400 transition-colors">
              CGV
            </Link>
          </div>
        </div>
      </div>
    </footer>
    {/* Spacer for mobile sticky CTA bar */}
    <div className="h-16 lg:hidden"></div>
    </>
  );
};

export default Footer;
